<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        size="sm"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected" class="varieables">
        <div class="inp">
          <label>{{ $t('fracao-de-solidos-na-saida') }}</label>
          <input
            v-model="xSolidosSaida.value"
            type="number"
            step="0.01"
            min="0"
            max="100"
            @change="updateNode"
          />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      xSolidosSaida: {},
      operations: [
        { value: null, text:this.$t('selecione-uma-operacao-0')  },
      ],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      attrList: ["xSolidosSaida"],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.xSolidosSaida = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.caption
      );
      if (this.xSolidosSaida) this.xSolidosSaida.value = ParseToNumber(this.xSolidosSaida.value);
      
      this.updateNode();
    },

    "xSolidosSaida.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });
      });
    },

    updateNode() {
      this.node.attrs = [this.xSolidosSaida.clone()];
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/SFE/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();

    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 0px 0px 10px 10px;
  margin-right: 3px;
  color: #0009;
}

input {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.op {
  margin: 2%;
}
</style>